import React from 'react';
import { Award } from 'lucide-react';
import InfoRow from './InfoRow';
import PillList from './PillList';
import { LICENSE_LABELS } from '../../utils/licenseRelevance.generated';

export const requiredLicenseDetails = (relevance) =>
  (Array.isArray(relevance?.details) ? relevance.details : [])
    .filter((detail) => detail.requirement === 'required' && detail.state && LICENSE_LABELS[detail.licenseType]);

const statusLabel = (detail) => detail.status === 'listed' ? 'listed'
  : detail.status === 'willing' ? 'willing to obtain'
  : detail.status === 'unwilling' ? 'not willing to obtain'
  : detail.status === 'covered' ? detail.reasonCode === 'REVIEWED_COMPACT_AUTHORITY' ? 'compact authority confirmed' : 'active license confirmed'
  : 'not confirmed';

export default function ProfileLicensePills({ relevance }) {
  const details = requiredLicenseDetails(relevance);
  if (!details.length) return null;
  const items = details.map((detail) => ({
    label: `${detail.state} ${LICENSE_LABELS[detail.licenseType]} ${statusLabel(detail)}`,
    tooltip: detail.status === 'listed' ? 'Listed on the provider’s profile; active status has not been verified.'
      : detail.status === 'willing' ? 'Provider says they would obtain this license. The license is not confirmed as held.'
      : detail.status === 'covered' ? 'Current authority evidence supports this state and license type. Confirm credentials before placement.'
      : detail.status === 'unwilling' ? 'Provider says they are not willing to obtain this license.' : 'No current license or willingness is confirmed.',
  }));
  return <div className="profile-license-status" role="region" aria-label="State license status">
    <InfoRow Icon={Award}>
      <div className="profile-license-status__content">
        <PillList items={items.map((item) => item.label)} getTooltip={(label) => items.find((item) => item.label === label)?.tooltip} idPrefix="profile-license" />
      </div>
    </InfoRow>
  </div>;
}
